// extracted by mini-css-extract-plugin
export default {"inputBox":"InputField-inputBox","heading":"InputField-heading","subHeading":"InputField-subHeading"};